import React from 'react';
import styles from './assets/styles/styles.module.scss';
import Select from '~/modules/shared/components/Select';
import AGE_DATA, { COUNT_TEXT_DESCRIPTION, COUNT_TEXT_INSTRUCTION } from '~/constants/count_const';

class TestIntroduction extends React.Component {
  render() {
    const {
      onNameChangeHandler,
      onAgeChangeHandler,
      onGameStartClick,
      ageValue
    } = this.props;

    return (
      <React.Fragment>
        <div className={styles['introduction']}>
          <div className={styles['description']}>
            <div className={styles['description-container']}>
              <h2 className={styles['title']}>
                {COUNT_TEXT_DESCRIPTION.title}
              </h2>
              <p className={styles['text']}>
                {COUNT_TEXT_DESCRIPTION.description}
              </p>
              <div className={styles['data-selection']}>
                <div className={styles['name-selection']}>
                  <span className={styles['name-text']}>
                    {COUNT_TEXT_DESCRIPTION.nameTitle}
                  </span>
                  <input className={styles['name-input']} onChange={onNameChangeHandler} placeholder={COUNT_TEXT_DESCRIPTION.placeholder} />
                </div>
                <div className={styles['age-selection']}>
                  <span className={styles['age-text']}>
                    {COUNT_TEXT_DESCRIPTION.selectionTitle}
                  </span>
                  <Select
                    onAgeChangeHandler={onAgeChangeHandler}
                    ageValue={ageValue}
                    ageData={AGE_DATA}
                  />
                </div>
              </div>
            </div>
            <div className={styles['white-circle-wrapper']}>
              <div className={styles['white-circle']} />
            </div>
            <div className={styles['fox-image-wrapper']}>
              <div className={styles['fox-image']} />
            </div>
          </div>
          <div className={styles.instruction}>
            <h3 className={styles.caption}>{COUNT_TEXT_INSTRUCTION.caption}</h3>
            <ul className={styles.description_list}>
              {COUNT_TEXT_INSTRUCTION.descriptionList.map((item, index) => (
                <li className={styles.description_item} key={index}>{item}</li>
              ))}
            </ul>
            <p className={styles.warning}>
              {COUNT_TEXT_INSTRUCTION.warning}
            </p>
            <button className={`${styles.game_start_button} iq-tests-button`} type="button" onClick={onGameStartClick}>
              {COUNT_TEXT_INSTRUCTION.gameStartText}
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default TestIntroduction;
